/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentType from './AppointmentType/index'
import CancelAction from './CancelAction/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Appointment/Edit"
  
}) {
let appointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Edit.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-9u9G': dtColorsWhite,'--pt-2-9u9G': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-9u9G': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-9u9G': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-5-9u9G': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-6-9u9G': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-9u9G': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-8-9u9G': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-9-9u9G': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btc-10-9u9G': dtColorsNeutral200,'--bbc-11-9u9G': dtColorsNeutral200,'--brc-12-9u9G': dtColorsNeutral200,'--blc-13-9u9G': appointmentTypeDisplayColorIdValueData}}
 className={`views-block ${styles.Horizontal}`}
>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
{children}
</React.Fragment>)
}